<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <div class="mb-4" style="text-align: right" v-if="collegeType == 3">
        <b-button
          variant="success"
          v-b-modal.modal-1
          @click="getSubscriptions(), getStates(), getDepartments()"
          >Add Student</b-button
        >
      </div>
      <div class="mb-4" style="text-align: right" v-if="collegeType == 3">
        <b-button variant="success" @click="sampleExcel()"
          >Sample Excel</b-button
        >
      </div>
      <div class="mb-4" style="text-align: right" v-if="collegeType == 3">
        <b-button
          variant="success"
          v-b-modal.modal-2
          @click="getSubscriptions()"
          >Import Students</b-button
        >
      </div>
      <div>
        <b-modal
          id="modal-2"
          title="Import Students"
          size="xl"
          ref="modaltwo"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="closeModal2()"
        >
          <div class="row">
            <div class="col-md-6 form-group">
              Subscription
              <b-form-select
                class="form-control"
                v-model="subscription"
                @change="(subscriptionEmpty = false), allowedSudents()"
              >
                <option
                  v-for="(subscription, index) in subscriptions"
                  :key="index"
                  :value="subscription.subscriptions.id"
                >
                  {{ subscription.subscriptions.name }}
                </option>
              </b-form-select>
              <div v-if="subscriptionEmpty" style="color: red">
                Subscription is required
              </div>
            </div>

            <div class="col-md-6 form-group">
              Import File (xls or csv)
              <b-form-file @change="uploadXL" required></b-form-file>
            </div>

            <div
              class="col-md-12 form-group text-center"
              v-if="saveButtonEnable && excelImport"
            >
              <b-button variant="success" @click="saveImport()">Save</b-button>
            </div>
          </div>
        </b-modal>
      </div>
      <div>
        <b-modal
          id="modal-1"
          title="Add Student"
          size="xl"
          ref="modalone"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="closeModal()"
        >
          <div class="row">
            <div class="col-md-6 form-group">
              Name
              <input
                v-model="name"
                class="form-control"
                @focus="nameEmpty = false"
              />
              <div v-if="nameEmpty" style="color: red">Name is required</div>
            </div>

            <div class="col-md-6 form-group">
              Email
              <input
                type="email"
                v-model="email"
                class="form-control"
                @focus="emailEmpty = false"
              />
              <div v-if="emailEmpty" style="color: red">
                Email is required
              </div>
            </div>

            <div class="col-md-6 form-group">
              Mobile Number
              <input
                type="number"
                v-model="mobile"
                class="form-control"
                @focus="mobileEmpty = false"
              />
              <div v-if="mobileEmpty" style="color: red">
                Mobile number is required
              </div>
            </div>

            <div class="col-md-6 form-group">
              College Name
              <input
                :value="$route.params.collegeName.split('-').join(' ')"
                class="form-control"
                readonly
              />
            </div>

            <div class="col-md-6 form-group">
              Registration Number
              <input
                type="number"
                v-model="registrationNumber"
                class="form-control"
                @focus="registrationNumberEmpty = false"
              />
              <div v-if="registrationNumberEmpty" style="color: red">
                Registration number is required
              </div>
            </div>

            <div class="col-md-6 form-group">
              State
              <b-form-select
                class="form-control"
                v-model="state"
                @change="stateEmpty = false"
              >
                <option
                  v-for="(state, index) in states"
                  :key="index"
                  :value="state.id"
                >
                  {{ state.name }}
                </option>
              </b-form-select>
              <div v-if="stateEmpty" style="color: red">
                State is required
              </div>
            </div>

            <div class="col-md-6 form-group">
              Department
              <b-form-select
                class="form-control"
                v-model="department"
                @change="departmentEmpty = false"
              >
                <option
                  v-for="(department, index) in departments"
                  :key="index"
                  :value="department.username"
                >
                  {{ department.username }}
                </option>
              </b-form-select>
              <div v-if="stateEmpty" style="color: red">
                Department is required
              </div>
            </div>

            <!-- <div class="col-md-6 form-group">
                Department
                <input
                  type="text"
                  v-model="department"
                  class="form-control"
                  @focus="departmentEmpty = false"
                />
                <div v-if="departmentEmpty" style="color: red">
                  Department is required
                </div>
              </div> -->

            <div class="col-md-6 form-group">
              Subscription
              <b-form-select
                class="form-control"
                v-model="subscription"
                @change="(subscriptionEmpty = false), allowedSudents()"
              >
                <option
                  v-for="(subscription, index) in subscriptions"
                  :key="index"
                  :value="subscription.subscriptions.id"
                >
                  {{ subscription.subscriptions.name }}
                </option>
              </b-form-select>
              <div v-if="subscriptionEmpty" style="color: red">
                Subscription is required
              </div>
            </div>
            <div
              class="col-md-12 form-group text-center"
              v-if="saveButtonEnable"
            >
              <b-button variant="success" @click="save()">Save</b-button>
            </div>
          </div>
        </b-modal>
      </div>

      <br />
      <base-block rounded title="Student List">
        <div class="d-flex justify-content-between mb-2">
          <div class="col-md-2 p-0">
            <b-form-select
              class="form-control"
              v-model="rows"
              @change="
                (pageSelected = 1),
                  (rowsAndFiltersClicked = true),
                  getCollegeUsers()
              "
            >
              <b-form-select-option value="10">10</b-form-select-option>
              <b-form-select-option value="25">25</b-form-select-option>
              <b-form-select-option value="50">50</b-form-select-option>
              <b-form-select-option value="100">100</b-form-select-option>
            </b-form-select>
          </div>

          <div class="mb-2">
            <input
              class="form-control"
              type="text"
              v-model="search"
              placeholder="Search..."
              aria-label="Search"
              style="width: 300px"
              @keyup="
                (pageSelected = 1),
                  (rowsAndFiltersClicked = true),
                  getCollegeUsers()
              "
            />
          </div>
        </div>

        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center" style="width: 100px">S.NO</b-th>
              <b-th class="text-center">User Name</b-th>
              <b-th class="text-center">Mobile Number</b-th>
              <b-th class="text-center">Department</b-th>
              <b-th class="text-center">Registration Number</b-th>
              <b-th class="text-center" style="width: 20%">Email</b-th>
              <b-th class="text-center">Registered Date</b-th>
              <b-th class="text-center">Logged In</b-th>
              <b-th class="text-center">Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-if="users.length == 0"
            ><b-tr
              ><b-td colspan="9" class="text-center"
                >No records found</b-td
              ></b-tr
            ></b-tbody
          >
          <b-tbody v-else>
            <b-tr v-for="(user, index) in users" :key="index">
              <b-td class="text-center">
                <!-- {{ currentPage - index - (currentPage - 1) * rows }} -->
                {{ (currentPage - 1) * rows + index + 1 }}
              </b-td>
              <b-td class="font-w600 font-size-sm text-center">
                {{ user.name ? user.name : "-" }}
              </b-td>
              <b-td class="text-center">{{
                user.mobile ? user.mobile : "-"
              }}</b-td>
              <b-td class="text-center">{{
                user.department ? user.department : "-"
              }}</b-td>
              <b-td class="text-center">{{
                user.registration_number ? user.registration_number : "-"
              }}</b-td>
              <b-td class="font-size-sm text-center">
                {{ user.email ? user.email : "-" }}
              </b-td>
              <b-td class="text-center">{{
                user.created_at | moment("D-M-YYYY h:mm a")
              }}</b-td>
              <b-td class="text-center" v-if="user.first_login_at">{{
                user.first_login_at | moment("D-M-YYYY h:mm a")
              }}</b-td>
              <b-td class="text-center" v-else>-</b-td>
              <b-td class="text-center">
                <div class="d-flex">
                  <router-link
                    :to="{
                      name: 'College User Profile',
                      params: { userId: user.id },
                    }"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-eye"></i>
                    </b-button>
                  </router-link>

                  <router-link
                    :to="{
                      name: 'College User Edit',
                      params: { userId: user.id },
                    }"
                    class="mx-2"
                  >
                    <b-button size="sm" variant="alt-primary">
                      <i class="fa fa-fw fa-pen"></i>
                    </b-button>
                  </router-link>
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <!-- pagination -->
        <div class="text-right" v-if="lastPage != 1 && users.length > 0">
          <b-button-group>
            <b-button
              size="lg"
              variant="outline-primary"
              @click="first()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[0].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-double-left"></i
            ></b-button>
            <b-button
              size="lg"
              variant="outline-primary"
              :disabled="
                totalPages.length > 0
                  ? totalPages[0].display
                    ? true
                    : false
                  : false
              "
              @click="previousPage()"
              ><i class="fas fa-angle-left"></i
            ></b-button>
            <b-button
              :pressed="page.activeStatus == true ? true : false"
              v-show="page.display"
              :id="page.id"
              @click="buttonClick(index)"
              size="lg"
              variant="outline-primary"
              v-for="(page, index) in totalPages"
              :key="index"
              >{{ index + 1 }}</b-button
            >
            <b-button
              size="lg"
              variant="outline-primary"
              @click="nextPage()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[totalPages.length - 1].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-right"></i
            ></b-button>
            <b-button
              size="lg"
              variant="outline-primary"
              @click="last()"
              :disabled="
                totalPages.length > 0
                  ? totalPages[totalPages.length - 1].display
                    ? true
                    : false
                  : false
              "
              ><i class="fas fa-angle-double-right"></i
            ></b-button>
          </b-button-group>
        </div>
        <!-- End Pagination -->
        <br />
        <!-- Loader -->
        <b-overlay
          :show="loader"
          no-wrap
          blur="2px"
          opacity="0.60"
          class="position-fixed"
        >
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
        <!-- End Loader -->
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      totalUsers: 0,
      rowsAndFiltersClicked: false,
      search: "",
      firstDisableStatus: false,
      lastDisableStatus: false,
      rows: 10,
      pageSelected: "",
      currentPage: "",
      lastPage: "",
      totalPages: [],
      loader: false,
      buttonVariant: "success",
      subscriptions: [],
      saveButtonEnable: false,
      name: "",
      nameEmpty: false,
      department: "",
      departmentEmpty: false,
      email: "",
      emailEmpty: false,
      mobile: "",
      mobileEmpty: false,
      registrationNumber: "",
      registrationNumberEmpty: false,
      state: "",
      stateEmpty: false,
      subscription: "",
      subscriptionEmpty: false,
      users: [],
      states: [],
      excelImport: "",
      collegeType: localStorage.getItem("collegeType") || "",
      collegeId: localStorage.getItem("collegeId") || "",
    };
  },
  mounted: async function() {
    await this.getCollegeUsers();
    // await this.getStudentList();
    this.pagination();
  },
  methods: {
    buttonClick(index) {
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[index].activeStatus = true;
      let displayedPages = this.totalPages.filter((ele) => ele.display == true);
      if (displayedPages[0] === this.totalPages[index]) {
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == false
        ) {
          this.totalPages[index - 1].display = true;
          this.totalPages[index - 2].display = true;
          this.totalPages[index + 3].display = false;
          this.totalPages[index + 4].display = false;
        }
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == true
        ) {
          this.totalPages[index - 1].display = true;
          this.totalPages[index + 4].display = false;
        }
      }
      if (displayedPages[1] === this.totalPages[index]) {
        if (
          this.totalPages[0].display == false &&
          this.totalPages[1].display == false
        ) {
          this.totalPages[index - 2].display = true;
          this.totalPages[index + 3].display = false;
        }
      }
      if (displayedPages[3] === this.totalPages[index]) {
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == false
        ) {
          this.totalPages[index + 2].display = true;
          this.totalPages[index - 3].display = false;
        }
      }
      if (displayedPages[4] === this.totalPages[index]) {
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == false
        ) {
          this.totalPages[index + 1].display = true;
          this.totalPages[index + 2].display = true;
          this.totalPages[index - 3].display = false;
          this.totalPages[index - 4].display = false;
        }
        if (
          this.totalPages[this.totalPages.length - 1].display == false &&
          this.totalPages[this.totalPages.length - 2].display == true
        ) {
          this.totalPages[index + 1].display = true;
          this.totalPages[index - 4].display = false;
        }
      }
      this.pageSelected = this.totalPages[index].id.split(" ")[1];
      this.getCollegeUsers();
    },
    last() {
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[this.totalPages.length - 1].activeStatus = true;
      for (var i = 0; i < this.totalPages.length; i++) {
        this.totalPages[i].display = false;
      }
      if (this.lastPage + 1 > 5) {
        for (var j = 0; j < 5; j++) {
          this.totalPages[this.totalPages.length - 1 - j].display = true;
        }
      } else {
        for (var k = 0; k < this.totalPages.length; k++) {
          this.totalPages[this.totalPages.length - 1 - k].display = true;
        }
      }
      this.pageSelected = this.totalPages.length;
      this.getCollegeUsers();
    },
    first() {
      this.totalPages = this.totalPages.map((ele) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
        }
        return ele;
      });
      this.totalPages[0].activeStatus = true;
      for (var i = 0; i < this.totalPages.length; i++) {
        this.totalPages[i].display = false;
      }
      for (var j = 0; j < 5; j++) {
        this.totalPages[j].display = true;
      }
      this.pageSelected = 1;
      this.getCollegeUsers();
    },
    previousPage() {
      var displayedPages = this.totalPages.filter((ele) => ele.display == true);
      let first = this.totalPages.indexOf(displayedPages[0]);
      let last = this.totalPages.indexOf(
        displayedPages[displayedPages.length - 1]
      );
      this.totalPages[first - 1].display = true;
      this.totalPages[last].display = false;
      this.totalPages = this.totalPages.map((ele, index, totalArray) => {
        if (ele.activeStatus == true) {
          ele.activeStatus = false;
          totalArray[index - 1].activeStatus = true;
        }
        return ele;
      });
      let currentPage = this.totalPages.find((ele) => ele.activeStatus == true);
      this.pageSelected = currentPage.id.split(" ")[1];
      this.getCollegeUsers();
    },
    nextPage() {
      var nextArrStatus = false;
      var displayedPages = this.totalPages.filter((ele) => ele.display == true);
      let first = this.totalPages.indexOf(displayedPages[0]);
      let last = this.totalPages.indexOf(
        displayedPages[displayedPages.length - 1]
      );
      this.totalPages[first].display = false;
      this.totalPages[last + 1].display = true;
      this.totalPages = this.totalPages.map((ele) => {
        var data = ele;
        if (data.activeStatus == true) {
          data.activeStatus = false;
          nextArrStatus = true;
        } else if (nextArrStatus) {
          data.activeStatus = true;
          nextArrStatus = false;
        }
        return data;
      });
      let currentPage = this.totalPages.find((ele) => ele.activeStatus == true);
      this.pageSelected = currentPage.id.split(" ")[1];
      this.getCollegeUsers();
    },

    pagination() {
      if (this.lastPage + 1 > 5) {
        this.totalPages = [];
        for (var i = 1; i < this.lastPage + 1; i++) {
          this.totalPages.push({
            id: `page ${i}`,
            display: false,
            activeStatus: false,
          });
        }
        this.totalPages = this.totalPages.map((ele, index) => ({
          ...ele,
          display: index < 5,
          activeStatus: index == 0,
        }));
      } else {
        this.totalPages = [];
        for (var j = 1; j < this.lastPage + 1; j++) {
          this.totalPages.push({
            id: `page ${j}`,
            display: false,
            activeStatus: false,
          });
        }
        this.totalPages = this.totalPages.map((ele, index) => ({
          ...ele,
          display: true,
          activeStatus: index == 0,
        }));
      }
    },

    // async getStudentList() {
    //   this.loader = true;
    //   await axios
    //     .get(
    //       `${this.$store.getters.baseUrl}/college_sub/college-admin/users?page=${this.pageSelected}&row=${this.rows}&search=${this.search}`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${this.$store.getters.collegeToken}`,
    //         },
    //       }
    //     )
    //     .then(async (response) => {
    //       console.log(response);
    //       if (response.data.status == "success") {
    //         this.subscriptions = await response.data.college_users;
    //         this.lastPage = response.data.pagination.last_page;
    //         this.currentPage = response.data.pagination.current_page;
    //         if (this.rowsAndFiltersClicked) {
    //           this.pagination();
    //           this.rowsAndFiltersClicked = false;
    //         }
    //         this.loader = false;
    //       } else {
    //         this.loader = false;
    //         this.$swal("Error", response.data.message, "warning");
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.loader = false;
    //       this.$swal("Error", error.response.data.message, "error");
    //     });
    // },

    async saveImport() {
      this.loader = true;
      if (this.subscription == "") {
        this.subscriptionEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("subscription_id", this.subscription);
      formdata.append("import_file", this.excelImport);
      formdata.append("college_admin_id", this.$store.getters.collegeId);
      await axios
        .post(`${this.$store.getters.baseUrl}/college_users_import`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal("Success", "Students imported successfully", "success");
            this.getCollegeUsers();
            this.$refs.modaltwo.hide();
            this.subscription = "";
            this.excelImport = "";
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    uploadXL(event) {
      this.excelImport = event.target.files[0];
    },

    allowedSudents() {
      var selectedSubscription = this.subscriptions.filter(
        (ele) => ele.subscriptions.id == this.subscription
      );
      console.log(selectedSubscription);
      if (
        selectedSubscription[0].user_subscriptions_count >=
        selectedSubscription[0].students_count
      ) {
        this.$swal(
          "Info",
          "Student adding limit exhausted for this subscription",
          "warning"
        );
        this.saveButtonEnable = false;
      } else {
        this.saveButtonEnable = true;
      }
    },

    closeModal2() {
      this.subscription = "";
      this.excelImport = "";
      this.subscriptionEmpty = false;
    },
    closeModal() {
      this.name = "";
      this.email = "";
      this.mobile = "";
      this.registrationNumber = "";
      this.state = "";
      this.subscription = "";
      this.nameEmpty = false;
      this.emailEmpty = false;
      this.mobileEmpty = false;
      this.registrationNumberEmpty = false;
      this.stateEmpty = false;
      this.subscriptionEmpty = false;
    },

    async getSubscriptions() {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_subscriptions`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subscriptions = response.data.subscriptions;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getDepartments() {
      await axios
        .get(`${this.$store.getters.baseUrl}/college_sub/departments?type=1`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
          console.log("departments");
          console.log(response);
          if (response.data.status == "success") {
            this.departments = response.data.departments;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getStates() {
      await axios
        .get(`${this.$store.getters.baseUrl}/state_list`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.collegeToken}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.states = response.data.states;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async save() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.email == "") {
        this.emailEmpty = true;
        return;
      }
      if (this.mobile == "") {
        this.mobileEmpty = true;
        return;
      }
      if (this.registrationNumber == "") {
        this.registrationNumberEmpty = true;
        return;
      }
      if (this.state == "") {
        this.stateEmpty = true;
        return;
      }
      if (this.department == "") {
        this.departmentEmpty = true;
        return;
      }
      if (this.subscription == "") {
        this.subscriptionEmpty = true;
        return;
      }

      const formdata = new FormData();
      formdata.append("name", this.name);
      formdata.append("email", this.email);
      formdata.append("mobile", this.mobile);
      formdata.append("department", this.department);
      formdata.append(
        "college_name",
        this.$route.params.collegeName.split("-").join(" ")
      );
      formdata.append("registration_number", this.registrationNumber);
      formdata.append("state_id", this.state);
      formdata.append("subscription_id", this.subscription);
      formdata.append("college_admin_id", this.$store.getters.collegeId);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/college_usersub_store`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal("Success", "Student added successfully", "success");
            this.getCollegeUsers();
            this.$refs.modalone.hide();
            this.name = "";
            this.email = "";
            this.mobile = "";
            this.registrationNumber = "";
            this.state = "";
            this.subscription = "";
            this.nameEmpty = false;
            this.emailEmpty = false;
            this.mobileEmpty = false;
            this.registrationNumberEmpty = false;
            this.stateEmpty = false;
            this.subscriptionEmpty = false;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getCollegeUsers() {
      this.loader = true;
      await axios
        .get(
          `${this.$store.getters.baseUrl}/college_sub/college-admin/users?page=${this.pageSelected}&row=${this.rows}&search=${this.search}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.collegeToken}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.users = response.data.college_users;
            this.lastPage = response.data.pagination.last_page;
            this.currentPage = response.data.pagination.current_page;
            if (this.rowsAndFiltersClicked) {
              this.pagination();
              this.rowsAndFiltersClicked = false;
            }
            this.loader = false;
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
